import request from '@/helpers/request'
import Vue from 'vue'
import * as Sentry from '@sentry/browser'

export default {
  START_CALL: ({ commit, state }, payload) => {
    request('POST', `${Vue.config.server}/${Vue.config.modules.crm.api.sipHistory.start}`, payload, true).then(
      response => {
        if (response.data.result === 'success') {
          return true
        } else {
          // TODO: Show error dialog
        }
      },
    )
  },

  END_CALL: ({ commit, state }, payload) => {
    request('POST', `${Vue.config.server}/${Vue.config.modules.crm.api.sipHistory.finish}`, payload, true).then(
      response => {
        if (response.data.result === 'success') {
          return true
        } else {
          // TODO: Show error dialog
        }
      },
    )
  },

  GET_ACTIVE_SIP_PARAM: ({ commit, state }) => {
    return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.sipParams.active}`, {}, true).then(
      response => {
        if (response.data.result === 'success') {
          const sipParam = response.data.data
          commit('setSipParam', sipParam.items)
        } else {
          // TODO: Show error dialog
        }
      },
    )
  },

  GET_USER_SIP_PARAM({ commit, state }, payload) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.one.replace('$1', payload)}`,
      {
        params: {
          with: 'sipParam',
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data

        commit('setUser', data)

        Sentry.configureScope(scope => {
          scope.setUser({
            id: _.get(data, 'id', null),
          })

          scope.setTag('unit', _.get(data, 'unit.name', null))
          scope.setTag('unit_id', _.get(data, 'unit.id', null))
        })
      } else {
        // TODO: Show error dialog
      }
    })
  },

  GET_SIP_HISTORY({ commit, state }, payload) {
    request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.iam}`, {}, true)
      .then(response => {
        if (response.data.result === 'success') {
          const user = response.data.data

          let params = payload ? payload : {}

          params = { searchFields: `employer_id:${user.id}`, ...params }

          return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.sipHistory.all}`, params, true)
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setSipHistory', state.sipHistory.concat(data))
        } else {
          // TODO: Show error dialog
        }
      })
  },

  GET_USER_BY_PHONE({ commit, state }, payload) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.users.all}`,
      {
        params: payload,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const user = response.data.data.items
        if (payload.type === 'incoming') {
          commit('setIncomingUser', user[0])
        }
      } else {
        // TODO: Show error dialog
      }
    })
  },

  GET_SIP_PARAMS: ({ commit, state }) => {
    request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.sipParams.all}`, {}, true).then(response => {
      if (response.data.result === 'success') {
        const sipParams = response.data.data
        commit('setSipParams', sipParams.items)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  STORE_SIP_PARAM({ commit, state }, payload) {
    request('POST', `${Vue.config.server}/${Vue.config.modules.crm.api.sipParams.all}`, payload, true).then(
      response => {
        if (response.data.result === 'success') {
          const sipParam = response.data.data
          commit('setSipParam', sipParam)
        } else {
          // TODO: Show error dialog
        }
      },
    )
  },
  SAVE_COMMENT({ commit, state }, payload) {
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.sipHistoryComment.all}`,
      payload.params,
      true,
    ).then(response => {
      if (response.data.result === 'success') {
      } else {
        // TODO: Show error dialog
      }
    })
  },
  APPEND_COMMENT({ commit, state }, payload) {
    request('POST', `${Vue.config.server}/${Vue.config.modules.crm.api.sipHistoryComment.all}`, payload.params, true)
      .then(response => {
        if (response.data.result === 'success') {
          return request(
            'GET',
            `${Vue.config.server}/${Vue.config.modules.crm.api.sipHistoryComment.one.replace(
              '$1',
              response.data.data.id,
            )}`,
            true,
          )
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        payload.callback()
        commit('appendSipHistoryComment', response.data.data)
      })
  },
  GET_SIP_HISTORY_COMMENTS({ commit, state }, payload) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.sipHistoryComment.all}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        commit('setSipHistoryComments', response.data.data.reverse())
        commit('setIsCommentsLoaded', true)
      } else {
        // TODO: Show error dialog
      }
    })
  },
}
